<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<p class="dedit">For Lefty</p>
<p class="dedi"><em class="italic">who may recognize</em></p>
<p class="dedi"><em class="italic">a couple of scenes</em></p>
<p class="dedi"><em class="italic">in this story</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedi.vue?9b483d68